import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AuthPage from './components/AuthPage';
import MessagePage from './components/MessagePage';

const App = () => {
  return (
    <Router>
      <Routes>
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/messages" element={<MessagePage />} />
        <Route path="/" element={<AuthPage />} />
      </Routes>
    </Router>
  );
};

export default App;
